import { render, staticRenderFns } from "./m_company006.vue?vue&type=template&id=4b070a86&scoped=true&"
import script from "./m_company006.vue?vue&type=script&lang=js&"
export * from "./m_company006.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b070a86",
  null
  
)

export default component.exports